import storageKeys from '../configuration/storageKeys'

export const getShipDestinationsData = () =>
  JSON.parse(sessionStorage.getItem(storageKeys.shipsDestinations))
